import { EXPORT_JUNCTURES } from '../../constants';

const initialState = {
  data: null,
  loading: true,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case EXPORT_JUNCTURES.LOAD:
      return {
        ...state,
        loading: true,
      };
    case EXPORT_JUNCTURES.SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload,
      };
    case EXPORT_JUNCTURES.FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
}
